import '@/app/styles/index.css';
import '@/app/i18n/i18n';
import App from '@/app/App';
import { loadClarity } from '@/app/bootstrap/clarity';
import { enableMocking } from '@/app/bootstrap/msw';
import { registerToastNotifier } from '@/app/bootstrap/notifier';
import { initSentry } from '@/app/bootstrap/sentry';
import { AppProviders } from '@/app/providers/AppProviders';
import { logger } from '@/shared/helpers/logger';
import { createRoot } from 'react-dom/client';

initSentry();
loadClarity();
registerToastNotifier();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

enableMocking().then(() => {
  createRoot(rootElement, {
    onUncaughtError: (error, errorInfo) => {
      logger.error('Uncaught error in React render', {
        error,
        errorInfo,
        log_source: 'createRoot',
      });
    },
    onCaughtError: (error, errorInfo) => {
      logger.error('Caught error in React render (handled by Error Boundary)', {
        error,
        errorInfo,
        log_source: 'createRoot',
      });
    },
  }).render(
    <AppProviders>
      <App />
    </AppProviders>,
  );
});
